module.exports = __webpack_public_path__ + "img/EE12674703.fa81b02f.png";